import { DesEncriptar } from "../Util/Encripcion";

// Deliberadamente NO usa la instancia de axios-config: su interceptor de
// error muestra un swal y hace window.location.reload() ante cualquier
// falla (401, 500, etc.), lo cual es inaceptable para un dato decorativo
// del footer — si esto falla, el footer simplemente cae a su fallback
// estático (ver contactenosParaFooter.js / footerDatosPorPais.js).

const RUTA_CONTACTENOS = "/it-api-clientes2/rs/operaciones/getParametrosGeneralesAPP/CONTACTENOS";

// El backend espera "pais=<idPais>-<codigoAseguradora>". El código de
// aseguradora normalmente se resuelve al seleccionar una póliza (ya
// autenticado); acá se usa un código fijo, público, sin sesión — por eso
// footerDatosPorPais.js/contactenosParaFooter.js solo piden con este código
// los datos que son iguales para cualquier aseguradora del país (web y
// redes sociales), nunca cabina/WhatsApp/correo (esos sí dependen de la
// póliza real del cliente).
export async function obtenerContactenosPorIdPais(idPais, codigoAseguradora, { timeoutMs = 3000 } = {}) {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), timeoutMs);
  const parametroPais = codigoAseguradora ? `${idPais}-${codigoAseguradora}` : idPais;

  try {
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}${RUTA_CONTACTENOS}?pais=${parametroPais}`,
      { signal: controller.signal }
    );

    // El backend responde 204 (sin cuerpo) cuando no hay parámetros
    // configurados para ese país todavía — no es un error, solo "sin datos".
    if (response.status === 204 || !response.ok) {
      return [];
    }

    const cuerpo = await response.json();
    if (!cuerpo || !cuerpo.datos) {
      return [];
    }

    const jsonPlano = DesEncriptar(cuerpo.datos);
    const datos = JSON.parse(jsonPlano);

    return Array.isArray(datos.ParametrosAppSomit) ? datos.ParametrosAppSomit : [];
  } catch (error) {
    // Red caída, timeout (AbortError), JSON inválido, etc.
    return [];
  } finally {
    clearTimeout(timeoutId);
  }
}
